import React,{useRef} from 'react'
import IPhone from './iphone';
import { Samsung } from './samsung';
import { useFrame } from '@react-three/fiber'
import { useGLTF } from '@react-three/drei'
import { angleToRadians } from './iphoneThreeCanvas';

const CombinedCanvas = () => {
    const { nodes, materials } = useGLTF('/models/GalaxyS10.glb')

    const meshRef = useRef()
    useFrame((state, delta) => (meshRef.current.rotation.y -= delta*0.05))
    return (
        <group ref={meshRef} name='large' position={[0, 0.2 ,0]}>
            <Samsung
                scale={[17.8, 17.8, 17.8]}
                rotation={[0, 0, 0]}
                position={[0, -1.4, 0.3]}
            />
            <IPhone 
                scale={[17, 17, 17]}
            />

            <mesh rotation={[-(angleToRadians(87)), 0, 0]} scale={[0.5,1.5,1]} position={[0, -1.4 ,0.15]} receiveShadow>
                <planeGeometry args={[5, 1, 5 ]}  />
                <meshStandardMaterial color="#000000" />
            </mesh>
        </group>
  )
}

export default CombinedCanvas